import { useEffect } from "react";
import {
  HashRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import GalleryIndex from "./pages/GalleryIndex";
import CategoryGallery from "./pages/gallery/CategoryGallery";
import Sitemap from "./pages/Sitemap";

import "@splidejs/react-splide/css";

// ScrollToTop component to reset scroll position on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Don't scroll if body position is fixed (modal is open)
    const isBodyFixed = document.body.style.position === "fixed";

    if (!isBodyFixed) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant", // Use 'smooth' for smooth scrolling or 'instant' for immediate jump
      });
    }
  }, [pathname]);

  return null;
}

function App() {
  // Smooth scroll for anchor links
  useEffect(() => {
    const handleAnchorClick = (e) => {
      const target = e.target.closest("a");
      if (!target) return;

      const href = target.getAttribute("href");
      if (!href || !href.startsWith("#")) return;

      e.preventDefault();
      const element = document.querySelector(href);
      if (!element) return;

      window.scrollTo({
        top: element.offsetTop - 80, // Adjust for header height
        behavior: "smooth",
      });
    };

    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);

  return (
    <Router>
      <Header />
      <ScrollToTop />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<GalleryIndex />} />
          <Route path="/gallery/:categoryId" element={<CategoryGallery />} />
          <Route path="/sitemap" element={<Sitemap />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
